module.exports = __webpack_public_path__ + "static/will-reflective-03-e788027902b0e7364cd561b9f7032995.jpg";